import styled from "styled-components";

const Text = styled.p`
  font-size: ${props =>
    props.size === "lg" ? "18px" : props.size === "xs" ? "10px" : "18px"};
  line-height: 1.75em;
`;

export default Text;



// WEBPACK FOOTER //
// ./src/UI/Text/Text.js